import {SliderLazy} from 'app/components/multimedia/gallery/slider/lazy';
import {getWebComponentLoader} from 'app/utils/initialize/getWebComponentLoader';

import {shouldSkipLazyLoad} from './shouldSkipLazyLoad';

export function defineMultimediaSlider(WebComponentLoader: ReturnType<typeof getWebComponentLoader>) {
    if (customElements.get('gem-multimedia-slider')) {
        return;
    }

    customElements.define(
        'gem-multimedia-slider',
        class extends WebComponentLoader {
            reactLazyComponent = SliderLazy;
            shouldSkipLazyLoad = shouldSkipLazyLoad;
        },
    );
}
